import { getPoolModels, getModelById, getModelBatchByIds } from '../api';

export const fetchPoolModels = async (poolId, setModels, setTotalModelPages, setLoading, page = 1, MODELS_PER_PAGE = 10) => {
    try {
        setLoading(true);
        const response = await getPoolModels(poolId);
        const modelIds = response.data || [];

        const startIndex = (page - 1) * MODELS_PER_PAGE;
        const endIndex = startIndex + MODELS_PER_PAGE;
        const paginatedModelIds = modelIds.slice(startIndex, endIndex);

        /*const modelDetails = await Promise.all(
            paginatedModelIds.map(async (modelId) => {
                const modelResponse = await getModelById(modelId);
                return modelResponse.data;
            })
        );*/
        const batchResponse = await getModelBatchByIds(paginatedModelIds);
        const modelDetails = batchResponse.data || [];

        setModels(modelDetails);
        setTotalModelPages(Math.ceil(modelIds.length / MODELS_PER_PAGE));
    } catch (err) {
        console.error('Error fetching models for pool:', err);
    } finally {
        setLoading(false);
    }
};